import React from 'react';

interface IconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const BusSvg: React.FC<IconProps> = ({ width, height, fill }) => {
  return (

    <svg width={width} height={height} viewBox="0 0 51 51" fill={fill} xmlns="http://www.w3.org/2000/svg" >
      <path d="M43.0312 17.5312H46.2188V23.9062H43.0312V17.5312Z" />
      <path d="M4.78125 17.5312H7.96875V23.9062H4.78125V17.5312Z" />
      <path d="M31.875 31.875H35.0625V35.0625H31.875V31.875Z" />
      <path d="M15.9375 31.875H19.125V35.0625H15.9375V31.875Z" />
      <path d="M33.4688 6.375H17.5312C15.4186 6.37753 13.3932 7.21791 11.8993 8.71179C10.4054 10.2057 9.56503 12.2311 9.5625 14.3438V36.6562C9.56334 37.5014 9.89944 38.3116 10.497 38.9092C11.0946 39.5068 11.9049 39.8429 12.75 39.8438V44.625H15.9375V39.8438H35.0625V44.625H38.25V39.8438C39.095 39.8425 39.905 39.5063 40.5025 38.9088C41.1 38.3113 41.4362 37.5012 41.4375 36.6562V14.3438C41.435 12.2311 40.5946 10.2057 39.1007 8.71179C37.6068 7.21791 35.5814 6.37753 33.4688 6.375ZM38.25 15.9375V25.5H12.75V15.9375H38.25ZM17.5312 9.5625H33.4688C34.4544 9.56543 35.4149 9.8734 36.2185 10.4441C37.0221 11.0149 37.6293 11.8203 37.9568 12.75H13.0433C13.3707 11.8203 13.9779 11.0149 14.7815 10.4441C15.5851 9.8734 16.5456 9.56543 17.5312 9.5625ZM12.75 36.6562V28.6875H38.2516L38.2532 36.6562H12.75Z" />
    </svg>

  );
};

export default BusSvg;